import {createRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/halloween';
import {setHalloweenModal, redeemHalloweenGift} from '../../../../reducers/app/actions';
import ButtonInactiveSvg from './button_inactive';
import ButtonActiveSvg from './button_active';
import TicketSVG from './ticket';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination, Autoplay} from 'swiper/modules'
import 'swiper/css';
import Title from './title';

export default () => {
    const {halloween, button} = useSelector(Selector),
          dispatch = useDispatch(),
          swiperRef = createRef();

    return (
        <div className="gifts-block">
            <Title />
            <div className="gifts">
                <div className="arrow" onClick={e => {
                    if(swiperRef.current)
                        swiperRef.current.slidePrev();
                }}>
                    <svg width="17" height="40" viewBox="0 0 17 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.19141 38.48L14.5031 23.2667C16.0752 21.47 16.0752 18.53 14.5031 16.7334L1.19141 1.52002" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div className="gifts-container">
                    <Swiper 
                        modules={[Autoplay]}
                        // autoplay={{
                        //     delay: 5e3
                        // }}
                        speed={500}
                        slidesPerGroup={1}
                        slidesPerView={1}
                        onBeforeInit={(swiper) => {
                            swiperRef.current = swiper;
                            console.log(swiper);
                        }}>
                        {halloween.gifts.map((gift, key) => {
                            const redeemed_gift = halloween.my_gifts.filter(g => g.key == gift.key)[0] || false;

                            return (
                                <SwiperSlide>
                                    <div className="gift" key={key}>
                                        {
                                            redeemed_gift
                                            ? <div className="amount">${redeemed_gift.amount}</div>
                                            : <div className="item animate__animated animate__pulse animate__infinite"></div>
                                        }
                                        {
                                            halloween.tickets < gift.price
                                            ? (
                                                <div className="h-button">
                                                    <div className="content">
                                                        {gift.price} <TicketSVG />
                                                    </div>
                                                    <ButtonInactiveSvg />
                                                </div>
                                            )
                                            : (
                                                <>
                                                    {
                                                        redeemed_gift
                                                        ? (
                                                            <div className="h-button">
                                                                <div className="content">
                                                                    Gift for {gift.price} <TicketSVG />
                                                                </div>
                                                                <ButtonInactiveSvg />
                                                            </div>
                                                        )
                                                        : (
                                                            <div className="h-button" onClick={e => {
                                                                dispatch(redeemHalloweenGift(gift.key))
                                                            }}>
                                                                {
                                                                    button
                                                                    ? (
                                                                        <>
                                                                            <div className="content">
                                                                                Please wait..
                                                                            </div>
                                                                            <ButtonInactiveSvg />
                                                                        </>
                                                                    )
                                                                    : (
                                                                        <>
                                                                            <div className="content">
                                                                                Get prize
                                                                            </div>
                                                                            <ButtonActiveSvg />
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                    </div>
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </div>
                <div className="arrow active" onClick={e => {
                    if(swiperRef.current)
                        swiperRef.current.slideNext();
                }}>
                    <svg width="17" height="40" viewBox="0 0 17 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.19141 38.48L14.5031 23.2667C16.0752 21.47 16.0752 18.53 14.5031 16.7334L1.19141 1.52002" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="tickets-count" onClick={e => dispatch(setHalloweenModal('tickets'))}>
                You have {halloween.tickets} <TicketSVG />
            </div>
        </div>
    )
}